<template>
    <div class="app-banner-wrapper" id="banner-app">
                <div class="cursor-pointer" @click="close()">
                <img src="@/assets/icons/cross-out.png">
            </div>
        <div class="app-banner">
            <div class="app-image">
                <img src="@/assets/icons/app_icon.png" alt="app image" />
                <span class="sdg-mobile-app">
                <p style="font-family:ProximanovaBold;font-size:38px">SDG</p>
                <p style="font-family:ProximanovaRegular;font-size:16px">Mobile App</p>
                </span>
            </div>
             <button
                      type="submit"
                      class="btn-lg-primary"
                      ref="loginBtnSubmit" aria-label="Sign In"  @click="appDownload()">
                      DOWNLOAD APP
                    </button>
        </div>
    </div>

</template>

<script>
export default {
    data() {
        return {

        }
    },
    methods:{
     checkDevice(){
         if(window){
         let device = navigator.userAgent.toLowerCase()
         if(window.mobilecheck()) {
        //    console.log("get inside")
           if(document.getElementById("banner-app")){
           document.getElementById("banner-app").style.display = "block"
         }
         }
     }
     },
     close(){
         if(document.getElementById("banner-app")){
         document.getElementById("banner-app").style.display = "none"
     }
     },
     appDownload(){
        //  console.log("AppDownload>>")
     
       let device = navigator.userAgent.toLowerCase()
       if(device.indexOf("android")!= -1) {
        //    console.log("eneter android")
           window.open("https://play.google.com/store/apps/details?id=com.sdg.android")
         
       }
       if(device.indexOf("mac")!= -1) {
            // console.log("eneter ios")
           window.open("https://apps.apple.com/us/app/sdg-soli-deo-gloria/id1484441478") 
       }

     }
    },

    created(){
        // this.checkDevice()
    }
    
}
</script>
<style scoped>
.app-banner-wrapper{
    position: static;
    z-index: 8898;
    top: 0px;
    height: 140px;
    padding-top: 16px;
	width: 100%;
	background-color: #FFFFFF;
	box-shadow: 0 -1px 15px 0 rgba(0,0,0,0.2);
}
.app-banner{
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    padding:  0% 5% 0 5%;
    width: 100%;
}

.app-image  img {
    margin: 0px 8% 0px 2%;
    width: 28%;
    height: 4em;
    text-align: center;
}

.sdg-mobile-app {
	color: #1F2228;
    display: inline-block;
    line-height: normal;
}

.cursor-pointer img{
 display: inline-block;
    opacity: 1;
    margin:0.5rem 1.25rem 0.4rem 90%;
    width: 1.18em;
    height: 1em;
    text-align: center;
}
.btn-lg-primary {
white-space: nowrap;
font-size: 12px;
height: fit-content;
margin-top: 14px;
padding: 14px;
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px)
{
    #banner-app{
        display: block;
    }
}
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 768px) {
    #banner-app{
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Header-prompt/AppBanner.vue